export const en = {
    allTime: 'All time',
    currentMonth: 'This month',
    currentWeek: 'This week',
    defaultBudgetMode: 'standard',
    last30Days: 'Last 30 days',
    last365Days: 'Last 365 days',
    last7Days: 'Last 7 days',
    last90Days: 'Last 90 days',
    previousMonth: 'Last month',
    previousWeek: 'Last week',
    'report-enqueued': 'Report request added to the queue',
    stretchedBudgetMode: 'distributed',
    today: 'Today',
    yesterday: 'Yesterday'
};
